// extracted by mini-css-extract-plugin
export default {"newsletter":"newsletterSub_newsletter__xr5CK"};